import React from 'react'

export interface ITitleProps {
    className?: string
    children?: string
}

const Title: React.FC<ITitleProps> = ({className, children}) => {
    return <p className={`text-h2 text-font01 ${className}`}>{children}</p>
}

export default Title
